import { useQuery, useQueryClient } from "react-query";
import { useAgentsHttp } from "../useAgentsHttp";
import type { AgentRun } from "../models/run";

interface RunsListResponse {
  runs: AgentRun[];
}

const QUERY_KEY = "inrange-agents-runs-list";

export const useRunsList = (project_id?: string) => {
  const http = useAgentsHttp();
  return useQuery<AgentRun[]>(
    [QUERY_KEY, project_id ?? null],
    async () => {
      const resp = await http<RunsListResponse>("/runs/list", {
        ...(project_id ? { project_id } : {}),
      });
      return resp.runs;
    },
    {
      // Operations dashboard rarely auto-refreshes; the explicit
      // Refresh button drives invalidation.
      refetchOnWindowFocus: false,
      staleTime: 60_000,
    },
  );
};

export const useInvalidateRunsList = () => {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: [QUERY_KEY] });
};
